import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import LoginPage from "../components/Pages/LoginPage";

import DashboardPage from "../components/Pages/DashboardPage";
import CreateAccessPage from "../components/Pages/CreateAccessPage";
import RequestResetPasswordPage from "../components/Pages/RequestResetPasswordPage";
import ResetPasswordPage from "../components/Pages/ResetPasswordPage";
// import DevicesPage from "../components/Pages/DevicesPage";
// import ReportsPage from "../components/Pages/ReportsPage";
// import OrdersPage from "../components/Pages/OrdersPage";
// import SettingsPage from "../components/Pages/SettingsPage";
// import EshopPage from "../components/Pages/EshopPage";

Vue.use(LoginPage);
Vue.use(CreateAccessPage);
Vue.use(RequestResetPasswordPage);
Vue.use(ResetPasswordPage);

Vue.use(DashboardPage);
// Vue.use(DevicesPage);
// Vue.use(ReportsPage);
// Vue.use(OrdersPage);
// Vue.use(SettingsPage);
// Vue.use(EshopPage);

import { ifAuthenticated } from "../middleware/authentication/ifAuthenticated";

const routes = [
  {
    path: "/",
    component: DashboardPage,
    name: "Dashboard",
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: "/devices",
  //   component: DevicesPage,
  //   name: "Devices",
  //   beforeEnter: ifAuthenticated
  // },
  // {
  //   path: "/reports",
  //   component: ReportsPage,
  //   name: "Reports",
  //   beforeEnter: ifAuthenticated
  // },
  // {
  //   path: "/orders",
  //   component: OrdersPage,
  //   name: "Orders",
  //   beforeEnter: ifAuthenticated
  // },
  // {
  //   path: "/settings",
  //   component: SettingsPage,
  //   name: "Settings",
  //   beforeEnter: ifAuthenticated
  // },
  // {
  //   path: "/eshop",
  //   component: EshopPage,
  //   name: "Eshop",
  //   beforeEnter: ifAuthenticated
  // },
  {
    path: "/login",
    component: LoginPage,
    name: "Login"
  },
  {
    path: "/claim-access/:token",
    component: CreateAccessPage,
    name: 'CreateAccessPage'
  },
  {
    path: "/request-password-reset",
    component: RequestResetPasswordPage,
    name: 'RequestResetPasswordPage'
  },
  {
    path: "/reset-password/:token",
    component: ResetPasswordPage,
    name: 'ResetPasswordPage'
  }
];

export default new VueRouter({
  mode: "history",
  linkActiveClass: "current",
  routes
});
